import { CardAccountMailIcon } from './CardAccountMailIcon';

/**
 * author: Google
 * id 81840940-8672-42C0-B657-15E94B3638D6
 * name card-account-mail
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-mail.svg
 * tags
 * - Account / User 
 */
export const ContactMailIcon = CardAccountMailIcon;
export default ContactMailIcon